import { default as _advancedFilters } from './advancedFilters.json';
import { default as _agentMgmt } from './agentMgmt.json';
import { default as _attributesMgmt } from './attributesMgmt.json';
import { default as _automation } from './automation.json';
import { default as _campaign } from './campaign.json';
import { default as _cannedMgmt } from './cannedMgmt.json';
import { default as _chatlist } from './chatlist.json';
import { default as _contact } from './contact.json';
import { default as _contactFilters } from './contactFilters.json';
import { default as _conversation } from './conversation.json';
import { default as _coupon } from './coupon.json';
import { default as _csatMgmtMgmt } from './csatMgmt.json';
import { default as _generalSettings } from './generalSettings.json';
import { default as _inboxMgmt } from './inboxMgmt.json';
import { default as _integrationApps } from './integrationApps.json';
import { default as _integrations } from './integrations.json';
import { default as _labelsMgmt } from './labelsMgmt.json';
import { default as _login } from './login.json';
import { default as _report } from './report.json';
import { default as _resetPassword } from './resetPassword.json';
import { default as _setNewPassword } from './setNewPassword.json';
import { default as _settings } from './settings.json';
import { default as _signup } from './signup.json';
import { default as _teamsSettings } from './teamsSettings.json';
import { default as _onboarding } from './onboarding.json';
import { default as _instructPopup } from './instructPopup.json';
import { default as _catalogue } from './catalogue.json';
import { default as _order } from './order.json';
import { default as _arrange } from './arrange.json';
import { default as _message } from './messageMgmt.json';
import { default as _ui_setting } from './ui_setting.json';
import { default as _calendarConst } from './calendarConst.json';
import { default as _billingUsages } from './billingUsages.json';
import { default as _ai } from './ai.json';

export default {
  ..._ai,
  ..._arrange,
  ..._advancedFilters,
  ..._agentMgmt,
  ..._attributesMgmt,
  ..._billingUsages,
  ..._automation,
  ..._campaign,
  ..._cannedMgmt,
  ..._chatlist,
  ..._contact,
  ..._contactFilters,
  ..._conversation,
  ..._coupon,
  ..._csatMgmtMgmt,
  ..._generalSettings,
  ..._inboxMgmt,
  ..._integrationApps,
  ..._integrations,
  ..._labelsMgmt,
  ..._login,
  ..._report,
  ..._resetPassword,
  ..._setNewPassword,
  ..._settings,
  ..._signup,
  ..._teamsSettings,
  ..._onboarding,
  ..._instructPopup,
  ..._catalogue,
  ..._order,
  ..._message,
  ..._ui_setting,
  ..._calendarConst,
};
